import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import { useShopSalePointId } from "../../hooks/shopSalePoint"
import { useShopPaymentPointId } from "../../hooks/shopPaymentPoint"
import { CheckCircle2, ShoppingBag } from "lucide-react"
import { useRouter } from "next/router"
import { useAtom as GetAtom } from "jotai"
import {
  checkoutDiscountAtom,
  checkoutIsNeedCalculateSumBackAtom,
  checkoutItemsAtom,
  checkoutModalDiscountOpenAtom,
  checkoutRaisePercentAtom,
  checkoutStepAtom,
  checkoutSumGiveAtom,
} from "../../store/checkout"
import { Button } from "@malond/ui/components/button"

export default function CheckoutFinishSuccess() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  useShopPaymentPointId()

  const router = useRouter()

  const [, setOpen] = GetAtom(checkoutModalDiscountOpenAtom)
  const [, setIsNeedCalculateSumBack] = GetAtom(
    checkoutIsNeedCalculateSumBackAtom
  )
  const [, setCheckoutItems] = GetAtom(checkoutItemsAtom)
  const [, setCheckoutDiscount] = GetAtom(checkoutDiscountAtom)
  const [, setRaisePercent] = GetAtom(checkoutRaisePercentAtom)
  const [, setCheckoutStep] = GetAtom(checkoutStepAtom)
  const [, setCheckoutSumGive] = GetAtom(checkoutSumGiveAtom)

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  const clearSale = async () => {
    setOpen(false)
    setIsNeedCalculateSumBack(false)
    setCheckoutItems([])
    setCheckoutDiscount("0")
    setRaisePercent("0")
    setCheckoutStep("0")
    setCheckoutSumGive("0")

    await router.push(`/e/${enterpriseId}/${shopId}/${shopSalePointId}/sales`)
  }

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop
  ) {
    return null
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <div className="text-center">
        <CheckCircle2 className="mx-auto size-24 text-emerald-500" />

        <p className="mt-3 mb-8 text-2xl font-bold text-foreground sm:text-3xl">
          Оплата завершена!
        </p>

        <Button
          type="button"
          size="lg"
          className="h-14 bg-primary px-8 text-lg font-semibold text-primary-foreground shadow-md hover:bg-primary/90"
          onClick={() => clearSale()}
        >
          <ShoppingBag className="mr-2 size-5" />
          Новая продажа
        </Button>
      </div>
    </div>
  )
}
